import {
  ArrowDownTrayIcon,
  ArrowUpTrayIcon, ChevronDoubleRightIcon,
  ExclamationTriangleIcon,
  SignalIcon, SignalSlashIcon, XMarkIcon
} from "@heroicons/react/20/solid";
import { Checkbox } from "../../../components/forms/Checkbox";
import { Panel } from "../../../components/panels/Panel";
import { createCsvData, downloadCsvData } from "../../../helpers/file/file-helper";
import { InputSelect } from "../../../components/forms/inputs/InputSelect";
import { useOrgData } from "../../../contexts/OrgDataContext";
import { DateRangePicker } from "@heroui/date-picker";
import { useState, useRef } from "react";
import { formatDateTimeFromTimestamp, calendarDateTimetoDate } from "../../../helpers/date/date-helper";
import { createDateRange } from "../../../services/live-interface/ergonomics-service";
import { useLocation } from "react-router-dom";

export const ErgonomicsFilters = ({ checkboxes, setCheckboxes, flags, filters, selectedDateRange, setSelectedDateRange }) => {

  const { workstations, workstationSelected, setWorkstationSelected } = useOrgData();

  const initialRange = useRef(selectedDateRange);

  const [range, setRange] = useState({
    start: formatDateTimeFromTimestamp(selectedDateRange.start),
    end: formatDateTimeFromTimestamp(selectedDateRange.stop),
  });

  const isLiveMode = new URLSearchParams(useLocation().search).has('live');

  const validateRange = () => {
    const startTimestamp = calendarDateTimetoDate(range.start).getTime();
    const stopTimestamp = calendarDateTimetoDate(range.end).getTime();
    setSelectedDateRange(createDateRange(startTimestamp, stopTimestamp));
  };

  const resetRange = () => {
    const startTimestamp = calendarDateTimetoDate(formatDateTimeFromTimestamp(initialRange.current.start)).getTime();
    const stopTimestamp = calendarDateTimetoDate(formatDateTimeFromTimestamp(initialRange.current.stop)).getTime();
    setRange({
      start: formatDateTimeFromTimestamp(initialRange.current.start),
      end: formatDateTimeFromTimestamp(initialRange.current.stop)
    });
    setSelectedDateRange(createDateRange(startTimestamp, stopTimestamp));
  };

  const handleFilterChange = (event) => {
    const { id, checked } = event.target;
    setCheckboxes((prev) => ({
      ...prev,
      [id]: checked,
    }));
  };

  const exportData = () => {
    let csvData = [
      ['Metrique', 'Valeur maximale', 'Valeur moyenne'],
      ['Position de la nuque', maxValues[1], Math.round(meanValues[1] * 10) / 10],
      ['Position du tronc', maxValues[2], Math.round(meanValues[2] * 10) / 10],
      ['Position des jambes', maxValues[3], Math.round(meanValues[3] * 10) / 10],
      ['Score de posture A', maxValues[4], Math.round(meanValues[4] * 10) / 10],
      ['Position de l\'epaule', maxValues[7], Math.round(meanValues[7] * 10) / 10],
      ['Position du coude', maxValues[8], Math.round(meanValues[8] * 10) / 10],
      ['Score de posture B', maxValues[10], Math.round(meanValues[10] * 10) / 10],
      ['Score de posture C', maxValues[13], Math.round(meanValues[13] * 10) / 10],
    ];
    downloadCsvData(createCsvData(csvData), 'REBA_scores');
  };

  const enableLiveMode = () => {
    const u = new URL(location.href);
    u.searchParams.set('live', '1');
    location.replace(u);
  };

  const disableLiveMode = () => {
    const u = new URL(location.href);
    u.searchParams.delete('live');
    location.replace(u);
  };

  const SHOW_BUTTONS = false;
  const SHOW_LIVE_MODE = true;

  return (
    <Panel title="FILTRES" height="h-1/3">
      {
        SHOW_BUTTONS &&
          <div className="flex justify-start items-center gap-4 mb-4">
            <button className="text-white bg-perception-blue px-4 py-2 text-sm flex items-center rounded-md" onClick={null}>
              <ArrowUpTrayIcon aria-hidden="true" className="size-4 mr-2" /> Importer chronique d'activité
            </button>

            <button className="text-white bg-perception-blue px-4 py-2 text-sm flex items-center rounded-md" onClick={exportData}>
              <ArrowDownTrayIcon aria-hidden="true" className="size-4 mr-2" /> Exporter
            </button>
          </div>
      }

      {
        SHOW_LIVE_MODE &&
        <div className="mb-4">
          {
            !isLiveMode ?
              <button className="text-white bg-perception-blue px-4 py-2 text-sm flex items-center rounded-md" onClick={enableLiveMode}>
                <SignalIcon aria-hidden="true" className="size-4 mr-2" /> Activer le mode temps réel
              </button>
            :
              <button className="text-white bg-perception-blue px-4 py-2 text-sm flex items-center rounded-md" onClick={disableLiveMode}>
                <SignalSlashIcon aria-hidden="true" className="size-4 mr-2" /> Arrêter le mode temps réel
              </button>
          }
        </div>
      }

      {
        !isLiveMode &&
        <div className="bg-perception-gray-800 mb-4 py-2 pb-4 px-1">
          <DateRangePicker
            classNames={{
              inputWrapper: 'bg-perception-gray-800 hover:bg-perception-gray-800 focus-within:hover:bg-perception-gray-800 text-white',
              label: 'text-white text-sm',
              input: 'bg-perception-gray-700 rounded-md px-2 w-auto'
            }}
            value={{
              start: range.start,
              end: range.end,
            }}
            className="" radius="none" granularity="minute" label="Période observée"
            onChange={({ start, end }) => setRange({ start, end })}
          />
          <div className="px-3 flex gap-2">
            <button className="text-xs text-white bg-perception-gray-700 py-1 px-2 flex items-center rounded-md" onClick={resetRange}>
              <XMarkIcon aria-hidden="true" className="size-4" />
            </button>
            <button className="text-xs text-white bg-perception-blue py-1 px-2 flex items-center rounded-md" onClick={validateRange}>
              Charger
            </button>
          </div>
        </div>
      }

      <div className="flex gap-4">
        <InputSelect
          items={workstations}
          onChange={setWorkstationSelected}
          itemToString={(item) => item?.name}
          defaultValue={workstationSelected}
        />
      </div>

      {
        !isLiveMode &&
        <>
          <div className="flex flex-wrap gap-x-4">
            {
              Object.entries(checkboxes).filter(([key, value]) => key !== 'workstation_id').map(([key, value], index) => (
                <Checkbox key={index} label={filters[index].display_text} id={key} checked={value} onChange={handleFilterChange} />
              ))
            }
          </div>

          {
            flags.filter((flag) => flag).length === 0 &&
              <div className="rounded-md bg-perception-black-500 p-2">
                <div className="flex">
                  <ExclamationTriangleIcon aria-hidden="true" className="size-5 text-yellow-400" />
                  <div className="ml-3">
                    <h3 className="text-sm font-medium text-yellow-400">Aucune donnée pour les critères sélectionnés.</h3>
                  </div>
                </div>
              </div>
          }
        </>
      }
    </Panel>
  );
};
